
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1i2wg_c17pi_157",
  "dismiss-button": "awsui_dismiss-button_1i2wg_c17pi_189",
  "dismiss-button-inline": "awsui_dismiss-button-inline_1i2wg_c17pi_230",
  "icon": "awsui_icon_1i2wg_c17pi_236",
  "icon-inline": "awsui_icon-inline_1i2wg_c17pi_242",
  "token-normal": "awsui_token-normal_1i2wg_c17pi_247",
  "token-inline": "awsui_token-inline_1i2wg_c17pi_254",
  "token-option-inline": "awsui_token-option-inline_1i2wg_c17pi_280",
  "token-box": "awsui_token-box_1i2wg_c17pi_284",
  "token-box-without-dismiss": "awsui_token-box-without-dismiss_1i2wg_c17pi_303",
  "token-box-inline": "awsui_token-box-inline_1i2wg_c17pi_307",
  "disable-padding": "awsui_disable-padding_1i2wg_c17pi_327",
  "token-box-readonly": "awsui_token-box-readonly_1i2wg_c17pi_334",
  "token-box-disabled": "awsui_token-box-disabled_1i2wg_c17pi_335"
};
  